import { render, staticRenderFns } from "./AdmissionMajorFormIndex.vue?vue&type=template&id=7aa13242&"
import script from "./AdmissionMajorFormIndex.vue?vue&type=script&lang=js&"
export * from "./AdmissionMajorFormIndex.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionMajorFormIndex.vue?vue&type=style&index=0&id=7aa13242&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports